import {useGetHostPhotosQuery, useGetPhotosQuery} from '~/ViewInvitation/api/endpoints/photos';

export const usePhotos = ({eventId, includeCount = false, isHostModule = false, perPage}) => {
  if (!eventId) return {};
  const useQuery = isHostModule ? useGetHostPhotosQuery : useGetPhotosQuery;

  const {data, isLoading} = useQuery({
    eventId,
    perPage,
    includeCount,
  });

  const photos = data?.photos ?? data?.objects ?? [];
  const title = data?.title;
  const photoCount = data?.total_count ?? photos?.length;

  return {photos, title, photoCount, isLoading};
};
